import { BrowserRouter } from "react-router-dom";
import React, { Suspense } from "react";
import { useAuthContext } from "./firebase-files/hooks/useAuthContext";
import { useEffect, useState } from "react";
// components
import ColorsComponent from "./default-components/ColorsComponent";
import PhoneLoginSignup from "./firebase-files/login/PhoneLoginSignup";

//LAUNCHING PAGE
import LaunchingPage from "./default-pages/launchingPage/LaunchingPage";

// HELMET
import { Helmet } from "react-helmet";

// styles
import "./App.css";
import { useDocument } from "./firebase-files/hooks/useDocument";
import FloatingSpeedDial from "./default-components/FloatingSpeedDial";

// Routes of all template start
import RouteOne from "./RouteOne";
import BusinessOneRoute from "./templates/business/businessOne/businessOneRoute/BusinessOneRoute";
import BusinessTwoRoute from "./templates/business/businessTwo/businessTwoRoute/BusinessTwoRoute";
// import CorporateOneRoute from "./templates/corporate/corporateOne/corporateOneRoute/CorporateOneRoute";
import BusinessThreeRoute from "./templates/business/businessThree/businessThreeRoute/BusinessThreeRoute";
import CorporateTwoRoute from "./templates/corporate/corporateTwo/corporateTwoRoute/CorporateTwoRoute";
import EventOneRoute from "./templates/events/eventOne/eventOneRoute/EventOneRoute";
import EducationOneRoute from "./templates/education/educationOne/educationOneRoute/EducationOneRoute";
import EducationTwoRoute from "./templates/education/educationTwo/educationTwoRoute/EducationTwoRoute";
import SecurityOneRoute from "./templates/security/securityOne/securityOneRoute/SecurityOneRoute";
import AppStoreOneRoute from "./templates/app store/appStoreOne/appStoreOneRoute/AppStoreOneRoute";
import HappyerpRoute from "./templates/HappyERP/happyerpRoute/HappyerpRoute";
import SportOneRoute from "./templates/sports/sportOne/sportOneRoute/SportOneRoute";
import HealthOneRoute from "./templates/health/healthOne/healthOneRoute/HealthOneRoute";
import HealthTwoRoute from "./templates/health/healthTwo/healthTwoRoute/HealthTwoRoute";
import PlantationOneRoute from "./templates/environment/environmentOne/plantationOneRoute/PlantationOneRoute";
import BlackberryRoute from "./templates/blackberrys/bbRoute/BlackberryRoute";
import PlantationTwoRoute from "./templates/environment/environmentTwo/plantationTwoRoute/PlantationTwoRoute";
import FinanceRoute from "./templates/finance/financeRoute/FinanceRoute";
// Routes of all template end

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DiwaliTheme from "./default-components/DiwaliTheme";
import HoliTheme from "./default-components/HoliTheme";
import WomenDayTheme from "./default-components/WomenDayTheme";
import EcomTwoRoute from "./templates/ecommerce/ecomTwo/ecomTwoRoute/EcomTwoRoute";
import FunctionsSettings from "./allRoles/admin/FunctionsSettings.jsx";


function App() {
  const { user } = useAuthContext();

  const [currentModeStatus, setCurrentModeStatus] = useState("dark");

  const { document: dbPWADoc } = useDocument("settings", "PWA");

  const { document: dbDisplayModeDocuments } = useDocument("settings", "mode");

  const { document: dbLaunchingSoonDocuments } = useDocument(
    "settings",
    "launchingPage"
  );

  const { document: organisationDocument } = useDocument(
    "settings",
    "organisation"
  );

  const { document: loginPopupDocuments } = useDocument(
    "settings",
    "LoginPopup"
  );

  const { document: dbTemplatesDocuments } = useDocument(
    "settings",
    "templates"
  );

  const { document: dbTemplatesPaletteDocuments } = useDocument(
    "settings",
    "themePalette"
  );

  // const [isLoading, setIsLoading] = useState(true);
  const [activeTemplate, setActiveTemplate] = useState(null);
  const [deferredPrompt, setDeferredPrompt] = useState(false);
  useEffect(() => {
    if (dbPWADoc) {
      const timer = setTimeout(() => {
        setDeferredPrompt(dbPWADoc.status === "active");
      }, 5000); // Delay of 5 seconds

      return () => clearTimeout(timer); // Cleanup function to prevent memory leaks
    }
  }, [dbPWADoc]); // Runs only when dbPWADoc changes

  console.log("deferredPrompt", deferredPrompt);

  useEffect(() => {
    const fetchActiveTemplate = async () => {
      try {
        // Access the activeTemplate value from the fetched document
        if (dbTemplatesDocuments) {
          setActiveTemplate(dbTemplatesDocuments.activeTemplate);
        }
      } catch (error) {
        console.error("Error fetching active template:", error);
      } finally {
        // setIsLoading(false);
      }
    };

    fetchActiveTemplate();
  }, [dbTemplatesDocuments]);

  useEffect(() => {
    //First time set display mode from db to useState variable and also store the same value in localStorage
    if (
      localStorage.getItem("mode") === null ||
      localStorage.getItem("mode") === "null" ||
      localStorage.getItem("mode") === ""
    ) {
      // console.log('dbdisplaymode: ', dbDisplayModeDocuments && dbDisplayModeDocuments.displayMode)
      setCurrentModeStatus(
        dbDisplayModeDocuments && dbDisplayModeDocuments.displayMode
      );
      localStorage.setItem(
        "mode",
        dbDisplayModeDocuments && dbDisplayModeDocuments.displayMode
      );
    }
    // Function to handle changes in localStorage
    const handleStorageChange = () => {
      const storedValue = localStorage.getItem("mode");
      setCurrentModeStatus(storedValue);
    };

    // Call the function initially
    handleStorageChange();

    // Listen for changes in localStorage
    window.addEventListener("storage", handleStorageChange);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [dbDisplayModeDocuments]);

  // PWA CODE START
  function startChromeInstall() {
    if (deferredPrompt) {
      deferredPrompt.prompt();
    }
    setinstallPopupDiv(false);
  }

  const [installPopupDiv, setinstallPopupDiv] = useState(true);
  const closeInstallPopup = () => {
    setinstallPopupDiv(false);
  };
  // PWA CODE END

  return (
    <div className={currentModeStatus === "dark" ? "dark" : "light"}>
      {/* START HELMET CODE */}
      <Helmet>
        <title>{organisationDocument && organisationDocument.app_title}</title>
        <meta
          property="og:title"
          content={organisationDocument && organisationDocument.app_title}
        />
        <link
          rel="icon"
          href={organisationDocument && organisationDocument.FavIcon}
        />
        <meta
          name="description"
          content={organisationDocument && organisationDocument.seo_description}
        />
        <meta
          property="og:description"
          content={organisationDocument && organisationDocument.seo_description}
        />
        <meta
          name="keywords"
          content={organisationDocument && organisationDocument.seo_keywords}
        />
        <meta
          property="og:image"
          content={organisationDocument && organisationDocument.app_image}
        />
        <meta
          property="og:image:width"
          content={organisationDocument && organisationDocument.app_image_width}
        />
        {/* Defines the width of the Open Graph image (og:image). */}
        <meta
          property="og:image:height"
          content={
            organisationDocument && organisationDocument.app_image_height
          }
        />
        {/* Defines the height of the Open Graph image (og:image). */}
      </Helmet>
      {/* END HELMET CODE */}

      {dbTemplatesPaletteDocuments &&
        (dbTemplatesPaletteDocuments.activeThemePalette ===
        "defaultThemePalette" ? null : dbTemplatesPaletteDocuments.activeThemePalette ===
          "diwaliThemePalette" ? (
          // Diwali Theme will cover the entire body
          <DiwaliTheme />
        ) : dbTemplatesPaletteDocuments.activeThemePalette ===
          "holiThemePalette" ? (
          // Holi Theme will cover the entire body
          <HoliTheme />
        ) : dbTemplatesPaletteDocuments.activeThemePalette ===
          "womenDayThemePalette" ? (
          // Holi Theme will cover the entire body
          <WomenDayTheme />
        ) : null)}

      <div className="App">
        <BrowserRouter>
          {loginPopupDocuments &&
            loginPopupDocuments &&
            loginPopupDocuments.LoginPopop == true &&
            !user && (
              <div className="home-popup">
                <div className="login-popup-overlay"></div>
                <div className="popup-content">
                  <PhoneLoginSignup />
                </div>
              </div>
            )}

          <div>
            {/* PWA INSTALLATION CODE START */}
            {dbPWADoc && dbPWADoc.status === "active" && (
              <>
                {deferredPrompt && (
                  <div
                    className={
                      installPopupDiv
                        ? "install-popup-div open"
                        : "install-popup-div"
                    }
                  >
                    <div>
                      <span
                        onClick={closeInstallPopup}
                        className="material-symbols-outlined close-button"
                      >
                        close
                      </span>
                      <img
                        src={
                          organisationDocument && organisationDocument.FavIcon
                        }
                        alt=""
                      ></img>
                      <h1>
                        For swift and efficient access, consider installing the
                        app on your device.
                      </h1>
                      <button id="btn_install" onClick={startChromeInstall}>
                        Install App
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
            {/* PWA INSTALLATION CODE END */}

            <Suspense fallback={<div>Loading...</div>}>
              {!user &&
              dbLaunchingSoonDocuments &&
              dbLaunchingSoonDocuments.status === true ? (
                <>
                  <LaunchingPage />
                  <FloatingSpeedDial />
                  <ColorsComponent />
                </>
              ) : user &&
                user.role !== "admin" &&
                dbLaunchingSoonDocuments &&
                dbLaunchingSoonDocuments.status === true ? (
                <>
                  <LaunchingPage />
                  <FloatingSpeedDial />
                  <ColorsComponent />
                </>
              ) : (
                <div style={{ paddingTop: "70px" }}>
                  {activeTemplate === "defaultTemplate" ? (
                    <RouteOne />
                  ) : activeTemplate === "businessOne" ? (
                    <BusinessOneRoute />
                  ) : activeTemplate === "businessTwo" ? (
                    <BusinessTwoRoute />
                  ) : activeTemplate === "businessThree" ? (
                    <BusinessThreeRoute />
                  ) : activeTemplate === "corporateTwo" ? (
                    <CorporateTwoRoute />
                  ) : activeTemplate === "eventOne" ? (
                    <EventOneRoute />
                  ) : activeTemplate === "educationOne" ? (
                    <EducationOneRoute />
                  ) : activeTemplate === "educationTwo" ? (
                    <EducationTwoRoute />
                  ) : activeTemplate === "securityOne" ? (
                    <SecurityOneRoute />
                  ) : activeTemplate === "appStoreOne" ? (
                    <AppStoreOneRoute />
                  ) : activeTemplate === "happyerp" ? (
                    <HappyerpRoute />
                  ) : activeTemplate === "sportOne" ? (
                    <SportOneRoute />
                  ) : activeTemplate === "healthOne" ? (
                    <HealthOneRoute />
                  ) : activeTemplate === "healthTwo" ? (
                    <HealthTwoRoute />
                  ) : activeTemplate === "plantationOne" ? (
                    <PlantationOneRoute />
                  ) : activeTemplate === "plantationTwo" ? (
                    <PlantationTwoRoute />
                  ) : activeTemplate === "blackberrys" ? (
                    <BlackberryRoute />
                  ) : activeTemplate === "finance" ? (
                    <FinanceRoute />
                  ) : activeTemplate === "ecomTwo" ? (
                    <EcomTwoRoute />
                  ) : (
                    <div>
                      <Skeleton width="100%" height={60} />
                      <h3>
                        <Skeleton count={1} height={400}></Skeleton>
                      </h3>
                      <br />
                      <Skeleton width="100%" height={50} />
                      <br />
                      <Skeleton width="100%" height={50} />
                      <br />
                      <Skeleton width="100%" height={50} />
                    </div>
                  )}
                </div>
              )}
            </Suspense>
          </div>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
